import { useState } from 'react';
import DialogModal from '../../../../../atoms/dialog';
import NoResultFoundFilters from '../../../../../atoms/noResultsFilters';
import { Grid } from '@mui/material';
import InviteExpertForm from './form';
import { SelectedCards } from '../../type';
import { getOrdinalSuffix, handleInviteSubmit } from './helper';
import FormCancelSubmitBtns from '../../../../../atoms/formCancelSubmitBtns';
import { usePeMappingContext } from '../../helper';
import { useSnackbar } from 'notistack';
import { InviteBulkProps } from './type';


const InviteBulk = ({
  handleClose,
  isOpen,
  project_id,
  selectedCards,
  isReInvite,
  setLoading
}: InviteBulkProps) => {
  const [currentExpertIndex, setCurrentExpertIndex] = useState(0);
  const [currentExpert, setCurrentExpert] = useState<SelectedCards | null>(
    selectedCards.length ? selectedCards[0] : null
  );
  const { refetch } = usePeMappingContext();
  const { enqueueSnackbar } = useSnackbar();
  const handleSkipClose = () => {
    let userIndex = currentExpertIndex;
    userIndex++;
    setCurrentExpertIndex(userIndex);

    if (userIndex === selectedCards.length) {
      // All users processed
        handleClose();
    } else {
      setCurrentExpert(selectedCards[userIndex]);
    }
  };

const submitHandler = ({sendInviteValue, shareAgendaValue, selectedAgendasValue} : any) => {
    handleInviteSubmit({setLoading, pe_id: currentExpert?.pe_id, sendInviteValue, shareAgendaValue, selectedAgendasValue, handleClose: handleSkipClose, enqueueSnackbar, refetch});
  }
  return (
    <DialogModal
      title={`${isReInvite ? 'ReInvite' : 'Invite'} experts ${selectedCards.length > 1
        ? `(${getOrdinalSuffix(currentExpertIndex + 1)} of ${selectedCards.length} experts selected)`
        : ''} Expert - ${currentExpert?.expert_name} (${currentExpert?.expert_id})`}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      {selectedCards.length && currentExpert ? (
        <>
          <InviteExpertForm
            pe_id={currentExpert.pe_id}
            project_id={project_id}
            renderSubmitAndCloseComponent={() => (
              <>
                <FormCancelSubmitBtns
                  cancelLabel='Skip'
                  submitLabel='Submit & Next'
                  handleClose={handleSkipClose}
                />
              </>
            )}
            submitHandler={submitHandler}
          />
        </>
      ) : (
        <Grid container mt={"10px"}>
          <Grid item xs={12} mb="42px">
            <NoResultFoundFilters text="Please Select Users" />
          </Grid>
        </Grid>
      )}
    </DialogModal>
  );
};

export default InviteBulk;